import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ContainerOverviewGrid from "./ContainerOverviewGrid";
import LockerDetailsModal from "./LockerDetailsModal";

function ContainerOverviewView({
  layout,
  lockers,
  selectedHub,
  selectedHubName,
}) {
  const emptyLockerCount =
    lockers?.filter((l) => Number(l.status) === 1).length || 0;
  const navigate = useNavigate();

  const [selectedLocker, setSelectedLocker] = useState(null);

  return (
    <div className="rounded-xl bg-white shadow-[2px_2px_8px_0px_#0000001A] m-4 mt-0 p-5 flex flex-col h-[calc(100vh-92px-72px-20px)]">
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-4">
          <div className="relative w-[421px]">
            <svg
              className="absolute left-3 top-1/2 -translate-y-1/2"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                stroke="#DFDFDF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 22L20 20"
                stroke="#DFDFDF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <input
              placeholder="Search Batteries"
              className="w-full h-10 pl-11 pr-4 rounded-md border border-light-grey focus:border-primary focus:outline-none placeholder:font-aileron bg-background
    placeholder:font-semibold
    placeholder:text-xs
    placeholder:leading-none
    placeholder:capitalize
    placeholder:text-dark-gray"
            />
          </div>

          <div className="bg-[#EEE5C9] rounded-md px-3.5 py-[11px] font-poppins font-medium text-xs leading-[18px] flex gap-x-2 h-10 ">
            <img
              src="/assets/icons/battery/battery-disable-2.svg"
              className="w-4 h-4"
              alt="No Battery"
            />
            {emptyLockerCount} Empty Lockers
          </div>
        </div>

        <button
          type="button"
          className="
            bg-yellow
            hover:bg-yellow-dark
            rounded-md
            px-4
            py-2.5
            flex gap-x-2
            font-poppins font-medium text-xs leading-normal w-[186px]
          "
          onClick={() => navigate(`/batteries/smart-containers/${selectedHub}`)}
        >
          <img src="/assets/icons/battery/edit-2.svg" alt="Edit" />
          Edit Container Layout
        </button>
      </div>

      <div className="flex-1 min-h-0">
        <ContainerOverviewGrid
          rows={layout.rows}
          columns={layout.columns}
          rowNamingFormat={layout.rowNamingFormat}
          colNamingFormat={layout.colNamingFormat}
          lockers={lockers}
          disabledLockers={layout.disabledLockers}
          onLockerClick={setSelectedLocker}
          selectedHub={selectedHub}
          selectedHubName={selectedHubName}
        />

        <LockerDetailsModal
          locker={selectedLocker}
          selectedHub={selectedHub}
          selectedHubName={selectedHubName}
          onClose={() => setSelectedLocker(null)}
        />
      </div>
    </div>
  );
}

export default ContainerOverviewView;
